// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ExtendedAddress$PorterinFeature from "../../../containers/fare-estimate-v1/domain/entity/ExtendedAddress.mjs";

var default_customer_address_pickup_address = ExtendedAddress$PorterinFeature.initial_address(undefined);

var default_customer_address_drop_address = ExtendedAddress$PorterinFeature.initial_address(undefined);

var default_customer_address = {
  pickup_address: default_customer_address_pickup_address,
  drop_address: default_customer_address_drop_address,
  name: undefined,
  number: undefined,
  house: undefined
};

var error_unserviceable_text = "Sorry! No service is available";

var error_unserviceable_text_bn = "দুঃখিত! কোন সেবা পাওয়া যায় না";

var error_unserviceable_sub_text_pickup = "We do not serve pickup service from this area. Please change the pickup location";

var error_unserviceable_sub_text_pickup_bn = "আমরা এই এলাকা থেকে পিকআপ পরিষেবা প্রদান করি না। পিক আপ অবস্থান পরিবর্তন করুন";

var error_unserviceable_sub_text_dropoff = "We do not serve dropoff service from this area. Please change the dropoff location";

var error_unserviceable_sub_text_dropoff_bn = "আমরা এই এলাকা থেকে ড্রপঅফ পরিষেবা পরিবেশন না. ড্রপঅফ অবস্থান পরিবর্তন করুন";

var error_unserviceable_button_pickup = "Change Pickup Location";

var error_unserviceable_button_pickup_bn = "পিকআপ লোকেশন পরিবর্তন করুন";

var error_unserviceable_button_dropoff = "Change Dropoff Location";

var error_unserviceable_button_dropoff_bn = "ড্রপঅফ অবস্থান পরিবর্তন করুন";

var search_results_title = "Search Results";

var search_results_empty_title = "Start searching for places";

var search_results_empty_subtitle = "Search for nearby landmarks, building name, area or street name";

var pickup_address = "Pickup Address";

var dropoff_address = "Dropoff Address";

var error_unserviceable_sub_text = "We do not serve pickup service from this area. Please change the location";

var error_unserviceable_button = "Change Location";

var ga_cta_book_select_goods = "fe_review_select_goods_cta_tap";

var moe_cta_book_select_goods_parameter = "fe_review_select_goods_cta_tap_moe";

var ga_cta_book_now = "fe_estresult_cta_confirm_tap";

var moe_cta_book_now_parameter = "fe_estresult_cta_confirm_tap_moe";

var offers_text = "Get additional 20% off on this vehicle in the next step.";

var payment_method = "Payment Method";

var payment_method_cash = "Cash";

var book_now_button = "Book Now";

var view_breakup_button = "View Breakup";

export {
  error_unserviceable_text ,
  error_unserviceable_text_bn ,
  error_unserviceable_sub_text_pickup ,
  error_unserviceable_sub_text_pickup_bn ,
  error_unserviceable_sub_text_dropoff ,
  error_unserviceable_sub_text_dropoff_bn ,
  error_unserviceable_button_pickup ,
  error_unserviceable_button_pickup_bn ,
  error_unserviceable_button_dropoff ,
  error_unserviceable_button_dropoff_bn ,
  search_results_title ,
  search_results_empty_title ,
  search_results_empty_subtitle ,
  pickup_address ,
  dropoff_address ,
  error_unserviceable_sub_text ,
  error_unserviceable_button ,
  default_customer_address ,
  ga_cta_book_select_goods ,
  moe_cta_book_select_goods_parameter ,
  ga_cta_book_now ,
  moe_cta_book_now_parameter ,
  offers_text ,
  payment_method ,
  payment_method_cash ,
  book_now_button ,
  view_breakup_button ,
}
/* default_customer_address Not a pure module */
